<template>
  <div>
    <el-button type="primary" @click="handleAdd">新增</el-button>
    
    <el-table :data="tableData" style="width: 100%" border>
      <el-table-column prop="name" label="名称"></el-table-column>
      <el-table-column prop="image" label="图片" width="80">
        <template slot-scope="scope">
          <el-popover placement="right" trigger="hover" v-if="scope.row.image">
            <img :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 500px; height: 500px"/>
            <img slot="reference" :src="('https://gate.yilanbiaoge.cn/back/getImage/'+scope.row.image)" style="width: 40px; height: 40px"/>
          </el-popover>
        </template>
      </el-table-column>
      <el-table-column prop="quantity" label="数量"></el-table-column>
      <el-table-column label="操作">
        <template slot-scope="scope">
          <el-button size="mini" @click="handleEdit(scope.row)">编辑</el-button>
          <el-button size="mini" type="danger" @click="handleDelete(scope.row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 新增/编辑对话框 -->
    <el-dialog :title="dialogTitle" :visible.sync="dialogVisible"
               append-to-body>
      <el-form :model="form" ref="form" :rules="rules">
        <el-form-item label="名称" prop="name">
<!--          <el-input v-model="form.name"/>-->
          <MaterialLov v-model="form.childrenId" width="300px" @callBack="setFormItem"/>
        </el-form-item>
        <el-form-item label="数量" prop="quantity">
          <el-input-number v-model="form.quantity" :min="1"></el-input-number>
        </el-form-item>
      </el-form>
      <div slot="footer">
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="submitForm">确定</el-button>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';
import MaterialLov from "@/views/ticket/lov/MaterialLov.vue";

export default {
  components: {
    MaterialLov
  },
  props: {
    id: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      tableData: [],
      dialogVisible: false,
      dialogTitle: '',
      form: {
        id: null,
        name: '',
        quantity: 1
      },
      rules: {
        name: [{ required: true, message: '请输入名称', trigger: 'blur' }],
        quantity: [{ required: true, message: '请输入数量', trigger: 'blur' }]
      }
    };
  },
  mounted() {
    this.fetchData();
  },
  methods: {
    // 查询数据
    async fetchData() {
      try {
        const response = await requestTicket.post('/Ticketing/procedure/execute', {
          procedureName: "get_material_bom_p",
          parameters: [this.id]
        });
        this.tableData = response.data;
      } catch (error) {
        console.error('获取数据失败:', error);
      }
    },

    // 打开新增对话框
    handleAdd() {
      this.dialogTitle = '新增物料';
      this.form = { id: null, name: '', quantity: 1 ,materialId: this.id};
      this.dialogVisible = true;
    },

    // 打开编辑对话框
    handleEdit(row) {
      this.dialogTitle = '编辑物料';
      this.form = { ...row };
      this.dialogVisible = true;
    },

    setFormItem(item) {
      this.form.childrenId = item.id;
      this.form.name = item.name;
    },

    // 提交表单（新增/修改）
    async submitForm() {
      this.$refs.form.validate(async (valid) => {
        if (valid) {
          try {
            await requestTicket.post('/Ticketing/material-bom/save', this.form);
            this.$message.success('操作成功');
            this.dialogVisible = false;
            this.fetchData();
          } catch (error) {
            console.error('操作失败:', error);
            this.$message.error('操作失败');
          }
        }
      });
    },

    // 删除数据
    async handleDelete(id) {
      try {
        await this.$confirm('确认删除该记录?', '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        });
        
        await requestTicket.delete(`/Ticketing/material-bom/${id}`);
        this.$message.success('删除成功');
        this.fetchData();
      } catch (error) {
        if (error !== 'cancel') {
          console.error('删除失败:', error);
          this.$message.error('删除失败');
        }
      }
    }
  }
};
</script>

<style scoped>
.el-button {
  margin-bottom: 15px;
}
</style>